import { Option } from 'shared/types'
import { FormValues } from './ContractorForm.types'

export const getInitialValues = (
  countriesOptions: Option<string, number>[],
  phonePrefixes?: Option<string, number>[]
): FormValues => ({
  countryId: countriesOptions.length ? countriesOptions[0].value : 1,
  taxNumber: '',
  name: '',
  nationalBusinessRegistryNumber: '',
  street: '',
  buildingNumber: '',
  apartmentNumber: '',
  zipCode: '',
  city: '',
  phoneNumber: '',
  emailAddress: '',
  phonePrefix: phonePrefixes ? phonePrefixes[0].value : 1,
  isContactActive: true,
})
